import { Box, Button, IconButton, Modal, FormControl, InputLabel, MenuItem, Select, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useState, useEffect } from 'react';
import { themeColors } from "../utils/constants";
import InciteDark from '../../javascript/images/InciteDark.png'
import InciteLight from '../../javascript/images/Incite.png'
import { ThemeProvider } from '@mui/material/styles';
import { customSelectThemeModal, customSelectTheme, isDarkMode } from '../utils/constants';
import CountrySelector from '../utils/CountrySelector';
import EXCHANGE_COUNTRY_CODE_MAPPING from '../utils/CountryExchanges';
import TIMEZONES, { browserTimezoneRails } from '../utils/timezones';

const AboutUserModal = ({aboutUserModal, setAboutUserModal, userData, setUserData}) => {

  const [country, setCountry] = useState('');
  const [countryExchange, setCountryExchange] = useState(Object.keys(EXCHANGE_COUNTRY_CODE_MAPPING)[0]);
  const [timezone, setTimezone] = useState(browserTimezoneRails());

  useEffect(() => {
    if (userData.user_account_info?.country) {
      setCountry(userData.user_account_info.country);
    }
    if (userData.user_account_info?.selected_country_exchange) {
      setCountryExchange(userData.user_account_info.selected_country_exchange);
    }
  }, [userData.user_account_info]);

  const handleAccept = () => {
    setAboutUserModal(false);
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        query: `mutation ($profession: String!, $country: String!, $countryExchange: String!, $timezone: String!) {
          userProfessionCountry(profession: $profession, country: $country, countryExchange: $countryExchange, timezone: $timezone) {
            status
          }
        }`,
        variables: {
          profession: '',
          country: country,
          countryExchange: countryExchange,
          timezone: timezone,
        },
      })
    };

    try {
      fetch('/graphql', requestOptions)
        .then(response => response.json())
        .then(data => {
          if (data.errors) {
            console.log("GraphQL Errors:", data.errors);
          } else {
            setUserData({
              ...userData,
              ...{ show_user_profession: false, user_country: country },
              user_account_info: {
                ...userData.user_account_info,
                country: country,
                selected_country_exchange: countryExchange,
                timezone: timezone,
                onboarding_modal_dismissed: true,
              }
            });
          }
          return data.data;
        });
    } catch(e) {
      console.log("What was the error?", e);
    }
  };

  const labelColor = isDarkMode ? '#fff' : '#111827';
  const menuProps = {
    PaperProps: {
      style: {
        backgroundColor: isDarkMode ? 'rgba(55,55,55)' : '#fff',
        maxHeight: 300,
      },
    },
  };
  const selectStyle = { color: isDarkMode ? 'white' : 'inherit', textAlign: 'left' };
  const menuItemStyle = { backgroundColor: isDarkMode ? 'rgba(55,55,55)' : '#fff', color: isDarkMode ? 'white' : 'inherit' };

  return (
    <ThemeProvider theme={isDarkMode ? customSelectThemeModal : customSelectTheme}>
      <Modal
        open={aboutUserModal}
        onClose={() => {}}
        slotProps={{ backdrop: { style: { backgroundColor: 'rgba(0,0,0,0.5)' } } }}
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 320,
          maxHeight: '90vh',
          overflowY: 'auto',
          backgroundColor: isDarkMode ? '#222222' : '#ffffff',
          borderRadius: '14px',
          boxShadow: '4px 4px 4px 0px rgba(0,0,0,0.25)',
          padding: '40px 24px 24px 24px',
          textAlign: 'center',
          outline: 'none',
        }}>
          <IconButton
            size="small"
            onClick={() => {
              setAboutUserModal(false);
              fetch('/graphql', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ query: `mutation { dismissOnboardingModal { status } }` }),
              });
              setUserData({ ...userData, user_account_info: { ...userData.user_account_info, onboarding_modal_dismissed: true } });
            }}
            sx={{ position: 'absolute', top: 8, right: 8, color: '#999999' }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>

          <img src={isDarkMode ? InciteDark : InciteLight} style={{maxHeight: '100%', maxWidth: '90px'}}/>

          <Typography sx={{ mt: 2, mb: 2.5, fontSize: '13px', color: labelColor }}>
            Please complete the below sections so that we can better tailor your responses
          </Typography>

          <FormControl fullWidth sx={{ mb: 2, '& .MuiOutlinedInput-root': { backgroundColor: isDarkMode ? 'transparent' : '#D9E2F8', '& fieldset': { borderColor: '#cccccc' }, '&:hover fieldset': { borderColor: '#aaaaaa' }, '&.Mui-focused fieldset': { borderColor: '#aaaaaa' } }, '& .MuiInputBase-input': { backgroundColor: isDarkMode ? 'transparent' : '#D9E2F8' } }}>
            <CountrySelector country={country} setCountry={setCountry}/>
          </FormControl>

          <FormControl fullWidth sx={{ mb: 2, '& .MuiOutlinedInput-root': { backgroundColor: isDarkMode ? 'transparent' : '#D9E2F8', '& fieldset': { borderColor: '#cccccc' }, '&:hover fieldset': { borderColor: '#aaaaaa' }, '&.Mui-focused fieldset': { borderColor: '#aaaaaa' } } }}>
            <InputLabel id="exchange-select-label">Exchange Country</InputLabel>
            <Select
              labelId="exchange-select-label"
              value={countryExchange}
              label="Exchange Country"
              onChange={(e) => setCountryExchange(e.target.value)}
              style={selectStyle}
              MenuProps={menuProps}
            >
              {Object.keys(EXCHANGE_COUNTRY_CODE_MAPPING).map((k) => (
                <MenuItem key={k} value={k} style={menuItemStyle}>
                  {k} ({EXCHANGE_COUNTRY_CODE_MAPPING[k]})
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ mb: 2, '& .MuiOutlinedInput-root': { backgroundColor: isDarkMode ? 'transparent' : '#D9E2F8', '& fieldset': { borderColor: '#cccccc' }, '&:hover fieldset': { borderColor: '#aaaaaa' }, '&.Mui-focused fieldset': { borderColor: '#aaaaaa' } } }}>
            <InputLabel id="timezone-select-label">Timezone</InputLabel>
            <Select
              labelId="timezone-select-label"
              value={timezone}
              label="Timezone"
              onChange={(e) => setTimezone(e.target.value)}
              style={selectStyle}
              MenuProps={menuProps}
            >
              {TIMEZONES.map((tz) => (
                <MenuItem key={tz.value} value={tz.value} style={menuItemStyle}>
                  {tz.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Typography sx={{ mt: 1, fontSize: '12px', color: labelColor }}>
            Note: You can change these any time in your account settings
          </Typography>

          <Box sx={{ mt: 2 }}>
            <Button
              variant="contained"
              sx={buttonStyles}
              onClick={() => { if (country !== '') handleAccept(); }}
            >
              <Box sx={submitStyles}>Submit</Box>
            </Button>
          </Box>
        </Box>
      </Modal>
    </ThemeProvider>
  );
}

export default AboutUserModal;

const buttonStyles = {
  width: '245px',
  height: '34px',
  textTransform: 'none',
  borderRadius: '24px',
  background: themeColors.buttonColor,
  boxShadow: '2px 2px 4px rgba(0, 0, 0, 0.05)',
}

const submitStyles = {
  display: 'flex', fontWeight: '400', alignItems: 'center',
  justifyContent: 'center', textAlign: 'center', color: '#F2F2F2', fontSize: '14px',
}
